module.exports = __webpack_public_path__ + "heart-twilight-red.20e7ade5aa2e7c6f8cde.svg";


//////////////////
// WEBPACK FOOTER
// /vercel/path0/src/assets/img/heart-twilight-red.svg
// module id = ../../../../../src/assets/img/heart-twilight-red.svg
// module chunks = main